// ============================================================
// serverError.ts — the SERVER's own words for a refused request (pure;
// serverError.test.ts). Screens show this instead of a generic "Failed…"
// when the API answers 4xx with { error } (e.g. "Close date is before the
// open date (01/02/2025)."). Only the listed statuses count, so a 500 or a
// network failure still gets the screen's own fallback.
// ============================================================
export const serverErrorMessage = (err: unknown, statuses: number[] = [400, 403, 409, 422]): string | null => {
  const r = (err as { response?: { status?: number; data?: { error?: unknown } } } | null)?.response
  if (!r || typeof r.status !== 'number' || !statuses.includes(r.status)) return null
  return typeof r.data?.error === 'string' && r.data.error.trim() ? r.data.error : null
}
